jQuery(document).ready(function($) {
	$.helper = {

		handleScrollbar: function(option) {
			var scrollDiv = document.createElement('div')
			scrollDiv.className = 'scrollbar-measure'
			document.body.appendChild(scrollDiv)

			// Get the scrollbar width
			var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
			var hasScrollbar = window.innerWidth > document.documentElement.clientWidth

			if (option === 'open' && $('.scrollbar-measure').length === 1) {
				if (hasScrollbar) {
					//$('.m-pg-menu__overlay').css('margin-left', '');
					$('html').css('margin-right', scrollbarWidth)
					///$('body').css('margin-right', (-1 * scrollbarWidth));
				}
			} else if (option === 'close') {
				$('.m-pg-menu__overlay').css('margin-left', (scrollbarWidth / 2))
				$('html').css('margin-right', '')
				//$('body').css('margin-right', '');
			}

			// Delete the DIV
			document.body.removeChild(scrollDiv)
		},

		matchconfig: function(configarray, match) {
			var cdefault = {}

			for (var i in configarray) {
				//set fallback
				if (configarray[i].label === 'default') {
					cdefault = configarray[i].config
				}

				//if match with breakpoint
				if (configarray[i].label === match) {
					return configarray[i].config
				}
			}

			//fallback
			return cdefault
		},

		addlink: function(base, html, classname, callback) {
			var a = $(document.createElement('a'))
			a.addClass(classname)
			a.html(html)
			a.attr('href', '#')

			base.append(a)

			//with click event
			$(base).on('click', '.' + classname, function(e) {
				e.preventDefault()
				e.stopPropagation()

				if (typeof callback === 'function') {
					callback()
				}

				return false
			})
		},

		scrollto: function(obj_to_srcolltop, extra_offset) {

			var scrollDestination = obj_to_srcolltop.offset().top
			if (extra_offset) {
				scrollDestination += extra_offset
			}

			$('html, body').animate({scrollTop: scrollDestination}, 1000, 'easeInSine', function() {
			})
		},

		decodeHTMLEntities: function(str) {
			var element = document.createElement('div')

			if (str && typeof str === 'string') {
				str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '')
				str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '')
				element.innerHTML = str
				str = element.textContent
				element.textContent = ''
			}

			return str
		},

		get_event: function() {
			var clickevent = 'click'

			if ($.browser.is_mobile === true) {
				clickevent = 'touchstart'
			}

			if ($.browser.is_tablet === true) {
				clickevent = 'touchstart'
			}

			/*if (($.browser.is_mobile === true) || ($.browser.is_tablet === true)) {
			 clickevent = 'touchstart';
			 }*/

			return clickevent
		}
	}
})